// TODO: Fix this the next time the file is edited.
/* eslint-disable @typescript-eslint/no-explicit-any */
import { isArray } from 'types/common.types';
import { isEmpty } from 'utils/isEmpty';

type CleanOptions = {
  cleanKeys?: string[];
  cleanValues?: string[];
  emptyArrays?: boolean;
  emptyObjects?: boolean;
  emptyStrings?: boolean;
  NaNValues?: boolean;
  nullValues?: boolean;
  undefinedValues?: boolean;
};

export function deepClean(object: unknown | any, opts?: CleanOptions): any {
  const options = { ...opts };
  if (!options.cleanKeys) options.cleanKeys = [];
  if (!options.cleanValues) options.cleanValues = [];
  if (!options.emptyArrays) options.emptyArrays = false;
  if (!options.emptyObjects) options.emptyObjects = false;
  if (!options.emptyStrings) options.emptyStrings = false;
  if (!options.NaNValues) options.NaNValues = false;
  if (!options.nullValues) options.nullValues = false;
  if (!options.undefinedValues) options.undefinedValues = false;

  const {
    NaNValues,
    cleanKeys,
    cleanValues,
    emptyArrays,
    emptyObjects,
    emptyStrings,
    nullValues,
    undefinedValues,
  } = options;
  const isPlainObject = (value: any) => Object.prototype.toString.call(value) === '[object Object]';
  const transform = (
    obj: any,
    callback: (result: Record<string, any>, value: any, key: string) => void,
  ) => {
    const result = isArray(obj) ? [] : {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        callback(result, obj[key], key);
      }
    }
    return result;
  };

  return transform(object, (result: Record<string, any>, value: any, key: string) => {
    if (cleanKeys.includes(key)) return;
    if (isArray(value) || isPlainObject(value)) {
      value = deepClean(value, {
        NaNValues,
        cleanKeys,
        cleanValues,
        emptyArrays,
        emptyObjects,
        emptyStrings,
        nullValues,
        undefinedValues,
      });
    }
    if (cleanValues.includes(value)) return;
    if (emptyObjects && isPlainObject(value) && isEmpty(value)) return;
    if (emptyArrays && isArray(value) && !value.length) return;
    if (emptyStrings && value === '') return;
    if (NaNValues && Number.isNaN(value)) return;
    if (nullValues && value === null) return;
    if (undefinedValues && value === undefined) return;
    if (isArray(result)) return result.push(value);
    result[key] = value;
  });
}
